import { loadImg, getPxSrgbByImageData, transXYZtoCxCy, transRgbToCxCy, srgbTransXYZ, querySelector, getIndexFromRect, queryFirstCanvasChild } from "./utils/common";
import { SHAP_ENUM } from "./constant";
import RectDrawer from './lib/Rect';

/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    // 基础配置
    options: {
      // 是否自动清理缓存
      autoClearAche: true,
      // 绘制完成钩子函数
      onDrawEnd: null
    },
    // 上传的图片信息
    originImgData: {
      width: 0,
      height: 0,
      originImg: null
    },
    canvasImgData: {
      width: 0,
      height: 0,
      instance: null
    },
    // 上传图片的 canvas ctx对象
    originCtx: null,
    // 生成位图的 canvas ctx对象
    bitmapCtx: null,
    // 用于rgb转换为XYZ数据缓存池
    XYZ_DataAchePool: new Map(),
     // srgb的数据
    SRGB_List: [],
    // XYZ所有数据
    XYZ_List: [],
    // 是否在初始化数据
    isInitCom: true,
    // 由于加载图片需要异步 如果提前执行类似drawBitmap方法 会被推入队列
    callbackList: [],
    // 背景色
    bg_color: {},
  }
}

/**
 * 图片识别组件
 */
class DesignCanvas {
  constructor(props) {
    const data = props || {};

    this.init(data);
  }

  data = getDefaultData();

  isBgColorByXYZ(XYZ_DATA, bgXYZColor) {
    const bg_color = bgXYZColor || this.data.bg_color.XYZ || {};
    const { X, Y, Z } = XYZ_DATA;

    return `${X}${Y}${Z}` === `${bg_color.X}${bg_color.Y}${bg_color.Z}`;
  };

  async init(data) {
    // 初始化配置
    this.initOption(data.options);
    // 初始化图片数据 获取长宽数据
    await this.initImg(data);
    // 初始化canvas画布
    this.initCanvasCtx();
    // 初始化获取像素级别数据
    this.initPxData();

    this.data.isInitCom = false;

    // 执行队列方法
    (this.data.callbackList || []).forEach(fn => {
      fn && fn();
    })
  }

  /**
   * 初始化基础配置
   */
  initOption(options = {}) {
    const { onDrawEnd } = options;

    this.data.options = {
      ...this.data.options,
      ...options,
    }

    // 绘制完成钩子
    if (onDrawEnd) {
      this.data.options.onDrawEnd = onDrawEnd.bind(this)
    } else {
      delete this.data.options.onDrawEnd;
    }
  }

  /**
   * 清理缓存 防止内存溢出 可以主动调用 也可以通过配置autoClearAche: true自动清理
   */
  destory() {
    this.data = getDefaultData();
  }

  /**
   * 初始化图片数据 获取长宽数据
   * @param {*} data 
   */
  async initImg(data) {
    const { url, originImgData } = data;
    let img = null;

    try {
      if (originImgData && originImgData.tagName === 'IMG') {
        img = originImgData
      } else if (!!url) {
        img = await loadImg(url);
      } else {
        throw new Error('请传递正确url或者originImgData对象')
      }
  
      this.data.originImgData = {
        ...this.data.originImgData,
        width: img.width,
        height: img.height,
        originImg: img
      }
    } catch (e) {
      console.log('图片加载失败', e);
    }
  }

  /**
   * 初始化cavas画布
   * @param {*} data 
   */
  initCanvasCtx() {
    const { originImgData } = this.data;
    const { originImg, width, height } = originImgData;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(originImg, 0, 0, width, height);

    this.data.originCtx = ctx;
  }

  /**
   * 初始化获取像素级别数据 包括srgb和xyz
   */
  initPxData() {
    const { XYZ_DataAchePool, originImgData, originCtx } = this.data;
    const { width, height } = originImgData;

    const imgCanvasData = (originCtx.getImageData(0, 0, width, height) || {}).data;
    // 获取srgb数据
    const SRGB_List = getPxSrgbByImageData(imgCanvasData);
    // 转化为XYZ的数据
    const XYZ_List = [];
    const maxColourMap = {}

    // 遍历转化srgb为xyz 命中缓存池则优先取已转化的值
    for (let i = 0; i < SRGB_List.length; i++) {
      const srgb = SRGB_List[i];
      const ache = XYZ_DataAchePool.get(srgb);

      if (ache) {
        // 缓存
        XYZ_List.push(ache);

        maxColourMap[srgb] = !!maxColourMap[srgb] ? maxColourMap[srgb] + 1 : 1;
      } else {
        // 走编译
        const rgb = srgb.split(',');
        const XYZ = srgbTransXYZ(rgb[0], rgb[1], rgb[2]);

        XYZ_List.push(XYZ);
        XYZ_DataAchePool.set(srgb, XYZ);
      }
    }

    const bgColor = this.getBgColor(maxColourMap);

    this.data.SRGB_List = SRGB_List;
    this.data.XYZ_List = XYZ_List;
    this.data.bg_color = {
      RGB: bgColor,
      XYZ: XYZ_DataAchePool.get(bgColor)
    };
  }

  // 获取实例数据(由于部分数据需要加载图片 所以是异步)
  getAsyncInstacneData() {
    return new Promise((resolve, reject) => {
      if (this.data.isInitCom) {
        this.data.callbackList.push(() => {
          resolve(this.data);
        });
        return;
      }
      
      resolve(this.data);
    });
  }

  /**
   * 
   * @param {*} pos 坐标信息 { x: 100, y: 100 
   * }
   * @param {*} directionType 图片方向 1 横向 0 纵向
   * @returns 
   */
  getColorDataByPos(pos, containerWidth, containerHeight, directionType = 1) {
    return new Promise((resolve, reject) => {
      if (this.data.isInitCom) {
        this.data.callbackList.push(() => {
          console.log('datadata', this.data.SRGB_List);
          if (Array.isArray(pos)) {
            const colorDataList = [];
            
            pos.forEach(item => {
              const canvasData = this.data.originCtx.getImageData(item.x, item.y, 1, 1);
              const { data } = canvasData || [];
              // console.log('canvasData', canvasData);
              // const colorIndex = getIndexFromRect({
              //   x: item.x,
              //   y: item.y,
              //   directionType,
              //   width: containerWidth || this.data.canvasImgData.width,
              //   height: containerHeight || this.data.canvasImgData.height
              // })

              colorDataList.push({
                SRGB: `${data[0]},${data[1]},${data[2]},${data[3]}`,// this.data.SRGB_List[colorIndex],
                XYZ: this.data.XYZ_List[colorIndex],
                index: colorIndex,
                x: item.x,
                y: item.y,
              });
            })

            resolve(colorDataList);
          } else {
            const colorIndex = getIndexFromRect({
              x: pos.x,
              y: pos.y,
              directionType,
              width: containerWidth || this.data.canvasImgData.width,
              height: containerHeight || this.data.canvasImgData.height
            })

            resolve({
              SRGB: `${data[0]},${data[1]},${data[2]},${data[3]}`, // this.data.SRGB_List[colorIndex],
              XYZ: this.data.XYZ_List[colorIndex],
              index: colorIndex,
              x: item.x,
              y: item.y,
            });
          }
        });
        return;
      }
      
      resolve(this.data);
    });
  }

  getPixIndexFromImage() {

  }

  getBgColor(maxColourMap) {
    let bgColor = '';
    let maxBgCount = 0;

    Object
      .entries(maxColourMap)
      .forEach(([colorStr, count]) => {
        if (count > maxBgCount) {
          bgColor = colorStr;
          maxBgCount = count;
        }
    })

    return bgColor;
  }

  /**
   * 绘制点位图 建议不传且不设置高度 此处会自动等比计算
   */
  drawBitmap(container, drawOption = {}) {
    // 由于还在初始化数据中 将延迟执行绘制任务
    if (this.data.isInitCom) {
      this.data.callbackList.push(
        this.drawBitmap.bind(this, container, drawOption)
      );

      return;
    }
    // debugger
    // 获取渲染盒子实例
    const containerDom = querySelector(container);

    if (!containerDom) {
      throw new Error('不存在该节点 请传递参数 eg: #{id} .{className}');
    }

    // 清空原有元素
    containerDom.innerHTML = '';

    this.data.canvasImgData = {
      width: containerDom.offsetWidth,
      height: containerDom.offsetHeight,
      instance: containerDom
    };

    // 默认绘制矩形
    const shap = (drawOption.shape || SHAP_ENUM.RECT).toUpperCase();

    switch (shap) {
      // 绘制矩形
      case SHAP_ENUM.RECT:
        this.drawBitmapWithRect(containerDom, drawOption);
        break;
      // 绘制圆形
      case SHAP_ENUM.CIRCLE:
        this.drawBitmapWithCircle(containerDom, drawOption);
        break;
      default:
        this.drawBitmapWithRect(containerDom, drawOption);
    }

    if (this.data.options.autoClearAche) {
      // this.registDestory(containerDom);
    }
  }

  /**
   * 绘制矩形
   */
  drawBitmapWithRect(containerDom, drawOption) {
    // 创建矩形绘制
    const rectDraw = new RectDrawer({
      containerDom,
      drawOption,
      SRGB_List: this.data.SRGB_List,
      originImgData: this.data.originImgData
    });

    // 监听绘制完成的钩子
    rectDraw.addEventListener('onDrawEnd', (data) => {
      const { onDrawEnd } = this.data.options;

      this.data.bitmapCtx = data.bitmapCtx;

      onDrawEnd instanceof Function && onDrawEnd();
    });

    // 开始绘制
    rectDraw.draw();
  }

  /**
   * 绘制圆形
   */
  drawBitmapWithCircle() {
    return;
  }

  /**
   * 注册canvas销毁事件
   */
  registDestory(containerDom) {
    // const callback = (mutations, observer) => {
    //   console.log('mutations', mutations, observer);
    // }

    // const mutation = new MutationObserver(callback);

    // mutation.observe(containerDom,  {
    //   childList: true, // 监听子元素数量变动
    //   attributes: false,
    //   attributeOldValue: false,
    //   characterData: false,
    //   characterDataOldValue: false,
    //   subtree: false,
    // })
  }

  static getLightData(XYZ_DATA) {
    return (XYZ_DATA || {}).Y || 0;
  };

  static transXYZtoCxCy = transXYZtoCxCy;
  static transRgbaToXYZ = srgbTransXYZ;
  static transRgbToCxCy = transRgbToCxCy;
  static transCxCyToXYZ(str, totalNum) {
    const list = [];
    const XYZ_List = [];
    const singleStrLength = Math.floor(str.length / totalNum);
    const light = Number(255).toString(16);

    for (let i = 0; i < str.length; i += singleStrLength ) {
      list.push(
        str.substr(i, singleStrLength).replace(new RegExp(`^${light}`, ), '')
      )
    };

    list.forEach(str => {
      XYZ_List.push(DesignCanvas.reverseTransCxCyToXYZ(str))
    });
  };
}

export default DesignCanvas;

export const loadAsyncImg = loadImg;